// Modules:
import React from 'react';

// Style:
import { GridFooter } from '@mui/x-data-grid-pro';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function CustomDataGridProFooter({ setMissingSuppressedModalOpen }) {
    return (
        <div className="custom-table-footer">
            <div
                className="missing-suppressed-info-container"
                onClick={() => setMissingSuppressedModalOpen(true)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        setMissingSuppressedModalOpen(true);
                    }
                }}
                role="button"
                tabIndex={0}
            >
                <p>*Missing or suppressed data?</p>
                <Typography>
                    <InfoOutlinedIcon />
                </Typography>
            </div>
            <GridFooter />
        </div>
    );
}

export default CustomDataGridProFooter;
